import { useListing } from 'framework-listing-lib/internal/providers/ListingProvider';
export default function useObjectTypeId() {
  const {
    objectType
  } = useListing();
  return objectType;
}